import { forwardRef, type TdHTMLAttributes } from 'react';
import { SortableTh } from '../SortableTh';

export const SortableHead = forwardRef<HTMLTableCellElement, TdHTMLAttributes<HTMLTableCellElement>>((props, ref) => (
  <SortableTh ref={ref} {...props} />
));
SortableHead.displayName = 'SortableHead';
